'use strict';

var isCssVar = require('./is-css-var.cjs');

function setStyle(element, name, value) {
    isCssVar.isCSSVar(name)
        ? element.style.setProperty(name, value)
        : (element.style[name] = value);
}

exports.setStyle = setStyle;
//# sourceMappingURL=style-set.cjs.map
